import { Rescatable } from '../Rescatable';

export class FetaureGrouper extends Rescatable {
  static _name = 'FetaureGrouper';
  static pathRequest = Rescatable.pathRequestStatic + 'armado/agrupadores_campos';
  static pk: keyof FetaureGrouper = 'id';
  id: number;
  nombre: string;
  orden: number;
  $caracteristicas?: any;
  constructor(CarouselBrand: FetaureGrouper) {
    super(CarouselBrand);
  }
}
